import React from 'react';
import { TButtonOption, TRowOption, TSelectorRegularOption } from '../../../types/options';
import { VisualView } from '../../Image/VisualView';

type TSelectorRegularLeftIcon = {
    /** Design version of the widget rendering the row (`TWidget.version`). */
    version: number | undefined;
} & Pick<TButtonOption, 'iconName' | 'iconHierarchy' | 'iconVariant'> &
    Pick<TRowOption, 'avatar' | 'flagIcon'> &
    Pick<TSelectorRegularOption, 'isDisabled' | 'variant'>;

export const SelectorRegularLeftIcon = ({ version, iconName, iconVariant, iconHierarchy, avatar, flagIcon, variant, isDisabled }: TSelectorRegularLeftIcon) => {
    if (variant) {
        return false;
    }
    if (iconName) {
        return (
            <VisualView
                version={version}
                iconName={iconName}
                rightMargin
                iconHierarchy={iconHierarchy}
                iconVariant={iconVariant}
                size={'small'}
                isDisabled={isDisabled}
            />
        );
    }
    if (avatar) {
        return <VisualView version={version} rightMargin avatar={avatar} size={'small'} isDisabled={isDisabled} />;
    }
    if (flagIcon) {
        return <VisualView version={version} rightMargin flagIcon={flagIcon} size={'small'} isDisabled={isDisabled} />;
    }
    return false;
};
